var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"el-form-item__description"},[_vm._v("\n    "+_vm._s(_vm.value ? _vm.value.length : 0)+"/"+_vm._s(_vm.limit)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }